module.exports = __webpack_public_path__ + "img/mote-50 1.c95f872e.png";